<template>
  <div class="Page">
    <div class="Inner">
      <h1 class="PageTitle">購入</h1>
      <Steps
        :total-steps="3"
        :labels="['入力', '確認', '完了']"
        :current-step="2"
      />
    </div>
    <Modal :show="showModal" @close="showModal = false">
      <template #body>
        <div class="LoadingModal">
          <div class="LoadingWrapper">
            <Loading/>
          </div>
          <div class="LoadingMessage">
            現在、決済処理中です。自動で画面が切り替わるまで1〜5秒ほどお待ちください。
          </div>
          <div class="LoadingSubMessage">
            ※しばらく経っても画面が切り替わらない場合は、<TextLink :to="contactLink" text="お問合せフォーム" target="_blank"/>からお問合せください。
          </div>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script lang="ts">
import {
  defineNuxtComponent,
} from "#app";
import { ref } from 'vue'
import { definePageMeta, useSeoMeta, useRuntimeConfig, useHead } from "#imports";
import { useProfileWeb } from '@/composables/useProfileWeb'
import { Steps, Loading, Modal, TextLink } from '@ka-nabellinc/ka-nabell-ui'

export default defineNuxtComponent({
  components: {
    Steps,
    Loading,
    Modal,
    TextLink
  },
  setup() {
    const showModal = ref(true) // 不具合の発生時にModalを閉じられるようにrefを用意
    const { contactLink } = useProfileWeb()
    const { public: { APP_ENV } } = useRuntimeConfig()

    const title = '決済待ち - カーナベル'
    useSeoMeta({
      title,
      ogTitle: title,
      robots: APP_ENV==='production' ? 'noindex,follow' :'noindex,nofollow',
    })
    definePageMeta({
      genre: 'pokemon',
      middleware: ['paypay-callback'],
      layout: 'simple'
    });

    return {
      showModal,
      contactLink
    }
  },
});
</script>

<style scoped>
.Page {
  width: 100%;
  padding: 20px 16px 48px;
  min-height: 456px;
}

.Inner {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
}

.PageTitle {
  width: 100%;
}

.LoadingModal {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 28px;
}

.LoadingWrapper {
  width: 88px;
  height: 88px;
}

.LoadingMessage {
  font-size: 14px;
  line-height: 150%;
  letter-spacing: 0.14px;
}

.LoadingSubMessage {
  font-size: 12px;
  line-height: 150%;
  letter-spacing: 0.12px;
}
</style>
